export const ApiUrl = 'https://devzone.pakodemy.com/api/';
export const ApiUrlAdmin = 'https://api.pakodemy.com/api/';
// export const ApiUrl = 'http://localhost:5001/';
